import type { JSX, ReactNode } from "react";

import { BrandMark } from "../shell/BrandMark.js";
import { Card, CardContent } from "../ui/card.js";
import { SVGLoader } from "../common/SVGLoader.js";

/**
 * Centered auth card (login / signup) — ported from the fynd-erp Business Hub
 * design: a white rounded card on a muted background, decorative grid pattern
 * peeking from the top corners, a logo chip, and a title/subtitle above the form.
 */
export function AuthShell({
  title,
  subtitle,
  children,
}: {
  title: string;
  subtitle: string;
  children: ReactNode;
}): JSX.Element {
  return (
    <main className="relative flex min-h-full items-center justify-center overflow-hidden bg-muted/40 p-6">
      <Card className="relative w-full max-w-md overflow-hidden rounded-2xl border-border/70 shadow-lg">
        {/* Decorative corner grid (top-left + mirrored top-right). */}
        <SVGLoader
          src="ic_login_background"
          className="pointer-events-none absolute left-0 top-0 w-44 opacity-60"
        />
        <SVGLoader
          src="ic_login_background"
          className="pointer-events-none absolute right-0 top-0 w-44 -scale-x-100 opacity-60"
        />

        <CardContent className="relative p-6 sm:p-8">
          <div className="mb-6 flex flex-col items-center text-center">
            <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-2xl border bg-white shadow-sm">
              <BrandMark className="h-9 w-9 text-foreground" />
            </div>
            <h1 className="text-2xl font-semibold tracking-tight text-foreground">{title}</h1>
            <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p>
          </div>
          {children}
        </CardContent>
      </Card>
    </main>
  );
}
